export default "__VITE_ASSET__c357a374__"